import { defineStore } from "pinia";
import { FavoriteTicket } from "./models/favorite-ticket";
import api from "./api/favorite-tickets-api";
import { ref } from "vue";

export const useFavoriteTicketsStore = defineStore("favoriteTickets", () => {
    const favoriteTickets = ref<FavoriteTicket[]>([]);
    const favoriteTicketsIds = ref<number[]>([]);

    const getFavoriteTicket = (externalSystemID: number) => {
        return favoriteTickets.value.find((ticket) => ticket.externalSystemID === externalSystemID);
    };

    const isFavoriteTicket = (externalSystemID: number) => favoriteTicketsIds.value.includes(externalSystemID);

    const loadFavoriteTickets = async () => {
        const favoriteTicketsResponse = await api.fetchFavoriteTickets();

        favoriteTickets.value = favoriteTicketsResponse;
        favoriteTicketsIds.value = favoriteTicketsResponse.map((ticket) => ticket.externalSystemID);
    };

    const createFavoriteTicket = async (externalSystemID: number) => {
        favoriteTicketsIds.value.push(externalSystemID);

        const ticket = await api.createFavoriteTicket(externalSystemID);
        if (!ticket) {
            favoriteTicketsIds.value = favoriteTicketsIds.value.filter((id) => id !== externalSystemID);
            return;
        }

        favoriteTickets.value = [...favoriteTickets.value, ticket];
    };

    const deleteFavoriteTicket = async (externalSystemID: number) => {
        favoriteTicketsIds.value = favoriteTicketsIds.value.filter((id) => id !== externalSystemID);
        favoriteTickets.value = favoriteTickets.value.filter((ticket) => ticket.externalSystemID !== externalSystemID);

        await api.deleteFavoriteTicket(externalSystemID);
    };

    const toggleFavoriteTicket = async (externalSystemID: number) => {
        if (isFavoriteTicket(externalSystemID)) {
            await deleteFavoriteTicket(externalSystemID);
        } else {
            await createFavoriteTicket(externalSystemID);
        }
    };
    return {
        favoriteTickets,
        favoriteTicketsIds,
        getFavoriteTicket,
        createFavoriteTicket,
        deleteFavoriteTicket,
        loadFavoriteTickets,
        isFavoriteTicket,
        toggleFavoriteTicket,
    };
});
